import React, { SVGProps } from 'react'
const SvgCustomerSupport = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={230}
    height={230}
    aria-hidden="true"
    {...props}
  >
    <defs>
      <filter
        id="CustomerSupport_svg__a"
        width="125.4%"
        height="125.4%"
        x="-12.7%"
        y="-9.7%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={4} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
      </filter>
      <filter
        id="CustomerSupport_svg__c"
        width="120.4%"
        height="120.4%"
        x="-10.2%"
        y="-7.8%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={4} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={5}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
      </filter>
      <filter
        id="CustomerSupport_svg__e"
        width="126.8%"
        height="119%"
        x="-13.4%"
        y="-6.8%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2}
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
      </filter>
      <path
        id="CustomerSupport_svg__b"
        d="M200 130.22c0-27.173-15.589-51.424-38.935-63.22-.725 52.1-42.965 94.34-95.065 95.065C77.796 185.41 102.047 201 129.22 201c12.74 0 25.129-3.393 36.015-9.84l34.456 9.53-9.53-34.455c6.446-10.886 9.839-23.275 9.839-36.016Z"
      />
      <path
        id="CustomerSupport_svg__d"
        d="M167 83.5C167 37.457 129.543 0 83.5 0S0 37.457 0 83.5c0 15.006 3.994 29.616 11.579 42.442L.307 166.692l40.75-11.27C53.885 163.005 68.495 167 83.5 167c46.043 0 83.5-37.457 83.5-83.5ZM70.687 64.066H57.873c0-14.13 11.496-25.626 25.627-25.626 14.131 0 25.627 11.495 25.627 25.626a25.69 25.69 0 0 1-8.334 18.912L89.907 92.94v9.993H77.093V87.299l15.05-13.774c2.689-2.461 4.17-5.82 4.17-9.459 0-7.065-5.747-12.813-12.813-12.813-7.066 0-12.813 5.748-12.813 12.813Zm6.406 51.68h12.814v12.814H77.093v-12.813Z"
      />
      <path
        id="CustomerSupport_svg__f"
        d="M21.632 54.184c-.624 0-1.144-.208-1.56-.624-.416-.416-.624-.901-.624-1.456 0-1.456.035-2.565.104-3.328.347-3.259 1.387-6.136 3.12-8.632 1.733-2.496 4.125-5.27 7.176-8.32 2.357-2.357 4.108-4.299 5.252-5.824 1.144-1.525 1.785-3.12 1.924-4.784.277-2.843-.641-5.096-2.756-6.76-2.115-1.664-4.663-2.496-7.644-2.496-6.725 0-10.781 3.363-12.168 10.088-.485 1.595-1.49 2.392-3.016 2.392H2.392c-.693 0-1.265-.243-1.716-.728C.226 23.227 0 22.602 0 21.84c.139-3.813 1.3-7.384 3.484-10.712 2.184-3.328 5.321-6.015 9.412-8.06C16.986 1.023 21.806 0 27.352 0c5.755 0 10.487.919 14.196 2.756 3.71 1.837 6.413 4.177 8.112 7.02 1.699 2.843 2.548 5.79 2.548 8.84 0 3.467-.78 6.483-2.34 9.048-1.56 2.565-3.865 5.512-6.916 8.84-2.219 2.357-3.935 4.385-5.148 6.084-1.213 1.699-2.028 3.519-2.444 5.46-.277 1.733-.45 2.912-.52 3.536-.347.901-.728 1.56-1.144 1.976-.416.416-1.005.624-1.768.624H21.632ZM21.32 73.84a2.407 2.407 0 0 1-1.768-.728 2.407 2.407 0 0 1-.728-1.768v-9.256c0-.693.243-1.283.728-1.768a2.407 2.407 0 0 1 1.768-.728h10.296c.693 0 1.3.243 1.82.728s.78 1.075.78 1.768v9.256c0 .693-.243 1.283-.728 1.768-.485.485-1.11.728-1.872.728H21.32Z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(15 15)">
      <g fillRule="nonzero">
        <use
          xlinkHref="#CustomerSupport_svg__b"
          fill="#000"
          filter="url(#CustomerSupport_svg__a)"
        />
        <use
          xlinkHref="#CustomerSupport_svg__b"
          fill={props.fill || 'var(--color-cta)'}
        />
      </g>
      <g fillRule="nonzero">
        <use
          xlinkHref="#CustomerSupport_svg__d"
          fill="#000"
          filter="url(#CustomerSupport_svg__c)"
        />
        <use xlinkHref="#CustomerSupport_svg__d" fill="#23B998" />
      </g>
      <circle cx={76} cy={89} r={57} fill="#23B998" />
      <g fillRule="nonzero" transform="translate(56.12 46.16)">
        <use
          xlinkHref="#CustomerSupport_svg__f"
          fill="#000"
          filter="url(#CustomerSupport_svg__e)"
        />
        <use xlinkHref="#CustomerSupport_svg__f" fill="#FFF" />
      </g>
    </g>
  </svg>
)
export default SvgCustomerSupport
